module.exports = __webpack_public_path__ + "img/done_refund.b0ab2f66.png";